import React from 'react'
import IrregularInteraction from '../../IrregularInteraction'
import ItemImage from '../../ItemImage'
import image from '../../../assets/images/bedroom/item--door@3x.png'

const path =
  'M1.91,0,0,1.1V197l6.6,3.81,1.78-1,75.54,43.63v1.95l6.6,3.81,1.91-1.1V52.18ZM8.51,13.74v-.1L70.29,49.23Z'

const Switch = props => (
  <IrregularInteraction
    path={path}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 92.44 249.19"
    {...props}
  >
    <ItemImage src={image} />
  </IrregularInteraction>
)

Switch.propTypes = IrregularInteraction.propTypes

export default Switch



// WEBPACK FOOTER //
// ./src/components/items/bedroom/Door.js